import { render, staticRenderFns } from "./MenuButtons.vue?vue&type=template&id=420dea98&"
import script from "./MenuButtons.vue?vue&type=script&lang=ts&"
export * from "./MenuButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports